var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "align-items-start text-gray3 font-size-14",
      attrs: { "data-cs-mask": "" },
    },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("p", [
        _vm.formattedAddressInfo.pto
          ? _c("span", [
              _vm._v(_vm._s(_vm.formattedAddressInfo.pto) + " :"),
              _c("br"),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.formattedAddressInfo.fullAddress
          ? _c("span", {
              domProps: {
                textContent: _vm._s(_vm.formattedAddressInfo.fullAddress),
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.formattedAddressInfo.phoneNumber
          ? _c("span", {
              domProps: {
                textContent: _vm._s(_vm.formattedAddressInfo.phoneNumber),
              },
            })
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("p", [
      _c("span", {
        staticClass: "icon icon-map-pin",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }